var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreviousIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.761735 3.11717L3.2819 0.531777C3.61005 0.195137 4.14295 0.195137 4.4711 0.531777C4.79925 0.868416 4.79925 1.41512 4.4711 1.75176L3.38953 2.86132H6.39535C8.71075 2.86132 10.5956 4.79498 10.5956 7.17031C10.5956 9.54564 8.71075 11.4793 6.39535 11.4793C5.9307 11.4793 5.5553 11.0942 5.5553 10.6175C5.5553 10.1408 5.9307 9.7557 6.39535 9.7557C7.78407 9.7557 8.91552 8.59497 8.91552 7.17031C8.91552 5.74565 7.78407 4.58492 6.39535 4.58492H3.37641L4.46323 5.69987C4.79137 6.03651 4.79137 6.58321 4.46323 6.91985C4.30047 7.08682 4.0852 7.173 3.86994 7.173C3.65467 7.173 3.43941 7.08952 3.27665 6.91985L0.761735 4.33446C0.433588 3.99782 0.433588 3.45381 0.761735 3.11717Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviousIcon);
export default __webpack_public_path__ + "static/media/PreviousIcon.0d228de6cccffff1246ed63afe9df2a5.svg";
export { ForwardRef as ReactComponent };